import { render, staticRenderFns } from "./umap_pcV.vue?vue&type=template&id=a38c2e9c&scoped=true&"
import script from "./umap_pcV.vue?vue&type=script&lang=js&"
export * from "./umap_pcV.vue?vue&type=script&lang=js&"
import style0 from "./umap_pcV.vue?vue&type=style&index=0&id=a38c2e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38c2e9c",
  null
  
)

export default component.exports